import { ActivityStage, TransportationActivityDto } from '@/api/portal'

export const activityComboTypeMapping: Record<TransportationActivityDto.comboType | string, string> = {
    [TransportationActivityDto.comboType.GOTO]: 'En Route to',
    [TransportationActivityDto.comboType.EMPTY]: 'Bobtail En Route to',
    [TransportationActivityDto.comboType.OFF_DUTY]: 'Off Duty',
    [TransportationActivityDto.comboType.BOBTAIL_GOTO]: 'Bobtail En Route to',
    [TransportationActivityDto.comboType.PICK_CHASSIS]: 'Pick Chassis',
    [TransportationActivityDto.comboType.PICK_UP_FULL]: 'Pick-up Full',
    [TransportationActivityDto.comboType.SCALE_FULL]: 'Scale - Full',
    [TransportationActivityDto.comboType.SCALE_TARE]: 'Scale - Tare',
    [TransportationActivityDto.comboType.DROP_FULL_WITH_OUT_CHASSIS]: 'Drop Full w/o Chassis',
    [TransportationActivityDto.comboType.DROP_FULL_WITH_CHASSIS]: 'Drop Full w/ Chassis',
    [TransportationActivityDto.comboType.DROP_CHASSIS]: 'Drop Chassis',
    [TransportationActivityDto.comboType.GET_UNLOADED]: 'Get Unloaded',
    [TransportationActivityDto.comboType.GET_LOADED]: 'Get Loaded',
    [TransportationActivityDto.comboType.PICK_UP_EMPTY]: 'Pick-up Empty',
    [TransportationActivityDto.comboType.DROP_EMPTY_WITH_OUT_CHASSIS]: 'Drop Empty w/o Chassis',
    [TransportationActivityDto.comboType.DROP_EMPTY_WITH_CHASSIS]: 'Drop Empty w/ Chassis',
}

export const activityStageColorMapping: Record<string | ActivityStage, string> = {
    [ActivityStage.PICKUP]: '#6973F6',
    [ActivityStage.PICKUP.toUpperCase()]: '#6973F6',
    [ActivityStage.DELIVERY]: '#A97DD8',
    [ActivityStage.DELIVERY.toUpperCase()]: '#A97DD8',
    [ActivityStage.RETURN]: '#3FB68E',
    [ActivityStage.RETURN.toUpperCase()]: '#3FB68E',
}

export const activityDocumentComboTypeMapping: Record<TransportationActivityDto.comboType | string, string> = {
    [TransportationActivityDto.comboType.PICK_CHASSIS]: 'Chassis PU',
    [TransportationActivityDto.comboType.PICK_UP_FULL]: 'Container PU',
    [TransportationActivityDto.comboType.DROP_FULL_WITH_OUT_CHASSIS]: 'Container DO',
    [TransportationActivityDto.comboType.DROP_FULL_WITH_CHASSIS]: 'Container DO',
    [TransportationActivityDto.comboType.DROP_CHASSIS]: 'Chassis DO',
    [TransportationActivityDto.comboType.PICK_UP_EMPTY]: 'Container PU',
    [TransportationActivityDto.comboType.DROP_EMPTY_WITH_OUT_CHASSIS]: 'Container DO',
    [TransportationActivityDto.comboType.DROP_EMPTY_WITH_CHASSIS]: 'Container DO',
}
